const EARTH_RADIUS_KM = 6371;

function toRadians(degrees) {
  return degrees * (Math.PI / 180);
}

function readCoordinate(point, key) {
  const number = Number(point && point[key]);
  return Number.isFinite(number) ? number : null;
}

export function haversineKm(a, b) {
  const latitudeA = readCoordinate(a, 'latitude');
  const longitudeA = readCoordinate(a, 'longitude');
  const latitudeB = readCoordinate(b, 'latitude');
  const longitudeB = readCoordinate(b, 'longitude');

  if (
    latitudeA === null
    || longitudeA === null
    || latitudeB === null
    || longitudeB === null
  ) {
    return Number.POSITIVE_INFINITY;
  }

  const deltaLatitude = toRadians(latitudeB - latitudeA);
  const deltaLongitude = toRadians(longitudeB - longitudeA);
  const latA = toRadians(latitudeA);
  const latB = toRadians(latitudeB);

  const h = Math.sin(deltaLatitude / 2) ** 2
    + Math.cos(latA) * Math.cos(latB) * Math.sin(deltaLongitude / 2) ** 2;

  return 2 * EARTH_RADIUS_KM * Math.atan2(Math.sqrt(h), Math.sqrt(1 - h));
}
